import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { LoadingHelper } from './shared/helpers/loading.helper';
import mixpanel from 'mixpanel-browser';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  showLoading?: Observable<boolean>;
  productionHost = 'ws3.wilsonsons.com.br';
  devToken = 'd80112009cc3626df070be45929846f9';
  prodToken = 'ef6b342b16cd1c7692fc2845018c377d';

  constructor(private loadingHelper: LoadingHelper) {}

  ngOnInit() {
    this.showLoading = this.loadingHelper.connect().pipe(debounceTime(300));

    if (window.location.host.toLowerCase().search(this.productionHost) < 0) {
      mixpanel.init(this.devToken);
    } else {
      mixpanel.init(this.prodToken);
    }
  }
}
